
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.961 5.934c2.4.206 3.38 1.44 3.38 4.14v.086c0 2.98-1.193 4.174-4.173 4.174h-4.34c-2.98 0-4.174-1.194-4.174-4.174v-.086c0-2.68.967-3.914 3.327-4.134M8 10V2.413","stroke":"#515952","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10.234 3.9L8.001 1.667 5.768 3.9","stroke":"#515952","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    